/** Path do Route dos  KPIs de Produtividade */
export const PRODUTIVIDADE_KPIS_PATH_ROUTE = 'produtividade';
